import { ThemeConfig } from 'antd/es/config-provider/context';

const themeConfig: ThemeConfig = {
  hashed: false, // disable css-dev-only-do-not-overwrite
  token: {
    fontWeightStrong: 500,
    fontFamily: `'Work Sans', sans-serif`,
    colorWhite: '#ffffff',
    colorLightGray: '#fafafa',
    colorSteelGray: '#555256',
    colorBlack: '#000000',
    colorTextBase: '#000000',
    colorTextLightSolid: '#ffffff',
    colorText: '#000000',
    colorTextHeading: '#000000',
    colorTextDescription: '#858287',
    colorTextPlaceholder: '#c3c1c3',
    colorTextDisabled: '#c3c1c3',
    colorIcon: '#858287',
    colorIconHover: '#000000',
    // emodo primary
    colorPrimary: '#6e28fc',
    colorPrimaryBg: '#F0F0FF',
    colorPrimaryBgHover: '#f5eeff',
    colorPrimaryBorder: '#e8ddff',
    colorPrimaryBorderHover: '#cebdff',
    colorPrimaryHover: '#9c7aff',
    colorPrimaryActive: '#5200ce',
    colorPrimaryTextHover: '#390094',
    colorPrimaryText: '#21005e',
    colorPrimaryTextActive: '#120338',
    // success
    colorSuccess: '#00d278',
    colorSuccessBg: '#f5fff3',
    colorSuccessBgHover: '#c2ffd1',
    colorSuccessBorder: '#5bffa0',
    colorSuccessBorderHover: '#35f090',
    colorSuccessHover: '#2ee286',
    colorSuccessActive: '#00c470',
    colorSuccessTextHover: '#00a65e',
    colorSuccessText: '#006d3b',
    colorSuccessTextActive: '#00391c',
    // error
    colorError: '#de3730',
    colorErrorBg: '#ffedea',
    colorErrorBgHover: '#ffdad6',
    colorErrorBorder: '#ffb4ab',
    colorErrorBorderHover: '#ff897d',
    colorErrorHover: '#ff5449',
    colorErrorActive: '#ba1a1a',
    colorErrorTextHover: '#93000a',
    colorErrorText: '#690005',
    colorErrorTextActive: '#410002',
    // warning
    colorWarning: '#ff6000',
    colorWarningBg: '#F0F0FF',
    colorWarningBgHover: '#ffede7',
    colorWarningBorder: '#ffdbce',
    colorWarningBorderHover: '#ffb598',
    colorWarningHover: '#ff8c5b',
    colorWarningActive: '#cf4c00',
    colorWarningTextHover: '#a63c00',
    colorWarningText: '#7e2c00',
    colorWarningTextActive: '#370e00',
    // info
    colorInfo: '#6e28fc',
    colorInfoBg: '#F0F0FF',
    colorInfoBgHover: '#f5eeff',
    colorInfoBorder: '#e8ddff',
    colorInfoBorderHover: '#cebdff',
    colorInfoHover: '#9c7aff',
    colorInfoActive: '#5200ce',
    colorInfoTextHover: '#390094',
    colorInfoText: '#21005e',
    colorInfoTextActive: '#120338',
    // backgrounds
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgContainerDisabled: '#f5f4f5',
    colorBgLayout: '#F0F0FF',
    colorBgElevated: '#ffffff',
    controlItemBgHover: '#cac5ca',
    controlItemBgActive: '#F0F0FF',
    controlItemBgActiveHover: '#f5eeff',
    colorBgTextHover: '#efeeef',
    colorFillContent: '#efeeef',
    colorFill: '#dad8da',
    // border and dividers
    colorBorder: '#dfdcdf',
    colorBorderBg: '#ffffff',
    colorBorderSecondary: '#efeeef',
    colorSplit: '#efeeef',
    // emodo purple
    purple1: '#FFFBFF',
    purple2: '#f5eeff',
    purple3: '#E8DDFF',
    purple4: '#CEBDFF',
    purple5: '#9c7aff',
    purple6: '#6e28fc',
    purple7: '#5200ce',
    purple8: '#390094',
    purple9: '#21005e',
    purple10: '#120388',
    // emodo cyan
    cyan1: '#F3FFF9',
    cyan2: '#B8FFEA',
    cyan3: '#62FBD9',
    cyan4: '#4AF0CC',
    cyan5: '#3CDEBD',
    cyan6: '#28D2B2',
    cyan7: '#00A389',
    cyan8: '#008771',
    cyan9: '#005143',
    cyan10: '#00382D',
    // custom colors
    disabledIconBg: '#cfbff0',
    disabledReportCardBg: '#aeaaae26',
    customBoxShadow: '#0000004d',
    gray: '#00000040',
    gray9: '#434343',
    secondaryButtonBoxShadow: '#00000005',
    colorBoxShadow3: '#00000008',
    transparentBorder: '#ffffff00',
    modalHeaderBg: '#6c23fa0d',
    layoutBorderColor: '#f4eff4',
    // Neutral color from Emodo theme https://www.figma.com/file/D7lyVDDL4eAjDBatf7bE8J/EMODO_Design_System_2022?type=design&node-id=51607-10284&t=PA2w5nkZRFv1NJFg-0
    // TODO: identify with design team which color system we need to use
    colorNeutral90: '#e6e1e6',
    gold: '#faad14',
    // fuschia and teal colors from https://www.figma.com/file/6RvWqNuC74apXaB3KsPZ6p/Campaign-Manager?type=design&mode=design&t=JhYNjwTWTRJvao1K-0
    fuschia3: '#FFD6F8',
    fuschia6: '#DB3EE3',
    teal3: '#62FBD9',
    teal6: '#28D2B2',
    colorLink: '#6E28FC',
  },
};

export default themeConfig;
